import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Box, Dialog, DialogContent, DialogTitle, Grid } from '@mui/material';
import CustomInput from '../CommonComp/CustomInput/CustomInput';
import CustomButton from '../CommonComp/Buttons/CustomButton';
import { useDispatch } from 'react-redux';
import { addCompanyGroup, companyGroupsListings } from '../../Services/companyApis';
import { DATA_LIMIT } from '../../data/constants';
import { categoryListings, createSubCategory, editSubCategory, subCategoryListings } from '../../Services/categoryApis';
import { useSearchParams } from 'react-router-dom';
import { action, logsMessagesList, modulesNames } from '../../data/logsMessages';
import { adminAddLogs } from '../../Services/commonService';

const limit = DATA_LIMIT;

function AddEditSubCategoryModal({ open, handleOpen, data, setPage, type, setSelectedCategory }) {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const categoryId = searchParams?.get('category_id')

  const handleConfirm = async (values, { resetForm }) => {
    setLoading(true)
    let resp = false;
    if (type == 'add') {
      resp = await createSubCategory({ ...values, sort_id: Number(values?.sort_id) })
      let payloadForLogs = {
                      action: action?.add,
                      module: modulesNames?.categories,
                      description: logsMessagesList?.categories?.categoriesImageSubCategoryAdded,
              };
              await adminAddLogs(payloadForLogs);
    }
    if (type == 'edit') {
      resp = await editSubCategory({ ...values, subcategory_id: data?.sno, sort_id: Number(values?.sort_id) })
      let payloadForLogs = {
                action: action?.update,
                module: modulesNames?.categories,
                description: logsMessagesList?.categories?.categoriesImageSubCategoryeEdit,
      };
      await adminAddLogs(payloadForLogs);
    }
    if (resp) {
      resetForm({
        subcategory_name: '',
        search_id: '',
        display_name: '',
        sort_id: '',
      })
      dispatch(subCategoryListings({
        page: String(1),
        limit: limit,
        category_id: categoryId,
      }))
      setPage(1)
      if (setSelectedCategory) {
        setSelectedCategory()
      }
      handleOpen(false)
    }
    setLoading(false)
  };

  const formik = useFormik({
    initialValues: {
      category_id: categoryId,
      subcategory_name: data?.name || '',
      search_id: data?.search_id || '',
      display_name: data?.display_name || '',
      sort_id: Number(data?.sort_id) || '',
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      subcategory_name: Yup.string().required('Sub-Category name is required.'),
      search_id: Yup.string().required('Search id is required.'),
      display_name: Yup.string().required('Display name is required.'),
      sort_id: Yup.string().matches(/^[0-9]+$/, "Must be only digits").required('Sort Id is required.'),
    }),
    onSubmit: handleConfirm,
  });

  return (
    <div>
      <Dialog
        maxWidth={'sm'}
        open={open}
        fullWidth
        onClose={() => {
          // handleOpen(false);
        }}
      >
        <DialogTitle variant="h3" padding={3}>
          {type == 'add' ? "Add Sub-Category" : "Edit Sub-Category"}
        </DialogTitle>
        <DialogContent>
          <Box
            noValidate
            component="form"
            onSubmit={formik.handleSubmit}
          >
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <CustomInput
                  variant="outlined"
                  fullWidth
                  name="subcategory_name"
                  label="Sub-Category Name"
                  placeholder="Sub-Category Name"
                  value={formik.values.subcategory_name}
                  onChange={formik.handleChange}
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    classes: {
                      notchedOutline: 'rounded',
                    },
                  }}
                  error={formik.touched.subcategory_name && Boolean(formik.errors.subcategory_name)}
                  helperText={formik.touched.subcategory_name && formik.errors.subcategory_name}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <CustomInput
                  variant="outlined"
                  fullWidth
                  name="search_id"
                  label="Search Id"
                  placeholder="Search Id"
                  value={formik.values.search_id}
                  onChange={formik.handleChange}
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    classes: {
                      notchedOutline: 'rounded',
                    },
                  }}
                  error={formik.touched.search_id && Boolean(formik.errors.search_id)}
                  helperText={formik.touched.search_id && formik.errors.search_id}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <CustomInput
                  variant="outlined"
                  fullWidth
                  name="display_name"
                  label="Display Name"
                  placeholder="Display Name"
                  value={formik.values.display_name}
                  onChange={formik.handleChange}
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    classes: {
                      notchedOutline: 'rounded',
                    },
                  }}
                  error={formik.touched.display_name && Boolean(formik.errors.display_name)}
                  helperText={formik.touched.display_name && formik.errors.display_name}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <CustomInput
                  variant="outlined"
                  fullWidth
                  name="sort_id"
                  label="Sort Id"
                  placeholder="Sort Id"
                  value={formik.values.sort_id}
                  onChange={formik.handleChange}
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    classes: {
                      notchedOutline: 'rounded',
                    },
                  }}
                  error={formik.touched.sort_id && Boolean(formik.errors.sort_id)}
                  helperText={formik.touched.sort_id && formik.errors.sort_id}
                />
              </Grid>
            </Grid>
            <div
              style={{ display: 'flex', justifyContent: 'end', marginTop: 15 }}
            >
              <CustomButton
                color={'buttonPrimary'}
                type="submit"
                loading={loading}
              >
                {type == 'add' ? 'Add' : 'Update'}
              </CustomButton>
              <CustomButton
                onClick={() => {
                  formik.resetForm({
                    subcategory_name: '',
                    search_id: '',
                    display_name: '',
                    sort_id: '',
                  });
                  handleOpen(false)
                }}
                disabled={loading}
              >
                Cancel
              </CustomButton>
            </div>
          </Box>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default AddEditSubCategoryModal;
